import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ASQ_SE2Logo from '/assets/images/asq_se2-logo.svg';
import ASQ_3Logo from '/assets/images/asq_3-logo.svg';
import { formatDateTime } from 'utils/Formatters';

const ASQ_TYPE_LOGOS = {
  'asq_se2': ASQ_SE2Logo,
  'asq_3': ASQ_3Logo,
}

const asqTypeLogo = (asqType) => {
  return ASQ_TYPE_LOGOS[asqType];
}

class FollowUpSurveysReportDetailsModal extends React.Component {
  render() {
    const { report } = this.props

    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('reports.details.title')}</b></h2>
        <hr className='u-margin-top--zero' />
        <table className='o-table o-table--bordered'>
          <tbody>
            <tr>
              <th>{this.props.t('reports.details.asqType')}</th>
              <td>
                <img style={{ height: '1.4rem', marginLeft: '0.4rem' }} src={asqTypeLogo(report.params.asq)} alt={report.params.asq} />
              </td>
            </tr>
            <tr>
              <th>{this.props.t('reports.details.requestedAt')}</th>
              <td>{formatDateTime(report.createdAt)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

FollowUpSurveysReportDetailsModal.propTypes = {
  report: PropTypes.object.isRequired,
}

export default withTranslation()(FollowUpSurveysReportDetailsModal)
